// Thin localStorage shims for the AI agent panel.
// Only chat session history is persisted, keyed per signed-in admin.

const SESSIONS_KEY_PREFIX = 'ringbaAiAgent.sessions.'
const MAX_SESSIONS = 25

function safeGet(key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function sessionsKey(userId) {
  return SESSIONS_KEY_PREFIX + (userId || 'anon')
}

export function getStoredSessions(userId) {
  const raw = safeGet(sessionsKey(userId))
  if (!raw) {
    return []
  }

  try {
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return []
    }

    return parsed.slice().sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))
  } catch (e) {
    return []
  }
}

export function saveStoredSessions(userId, sessions) {
  const key = sessionsKey(userId)
  let list = (Array.isArray(sessions) ? sessions.slice() : [])
    .sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0))
    .slice(0, MAX_SESSIONS)

  while (list.length) {
    try {
      localStorage.setItem(key, JSON.stringify(list))
      return list
    } catch (e) {
      list = list.slice(0, -1)
    }
  }

  try {
    localStorage.removeItem(key)
  } catch (e) { /* ignore */ }

  return []
}
